// extracted by mini-css-extract-plugin
export default {"wrapper":"CaseComponent_wrapper__lWXmj"};